module.exports = __webpack_public_path__ + "static/logi_logo-46f18e7afcfaf1324f5d.png";